var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"item-footer"}},[_c('div',{attrs:{"id":"description-cta"}},[_c('item-description',{ref:"description",attrs:{"id":"description"}}),_vm._v(" "),_c('cta-button',{ref:"cta",attrs:{"id":"cta"}})],1),_vm._v(" "),_c('item-tab-nav')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }